module.exports = __webpack_public_path__ + "static/media/bar-code-scan.2c4f03ea.svg";